/*
 * @Author: Json Chen
 * @Date: 2021-07-09 11:23:07
 * @LastEditTime: 2022-06-01 16:24:40
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/setting.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
// import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import CommonFormItem from '@/src/pages/Settings/Logistics/Components/Common';
import {
  getWareHouseLocation,
  setWareHouseLocation,
} from '@/src/request/settings/logistics/wareHouseLocation';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import useUrlState from '@ahooksjs/use-url-state';
import { useRequest } from 'ahooks';
import { Button, Checkbox, Form, Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { breadcrumbData as defaultBreadcrumbData } from '../config';
// import { Icon } from '@/src/tools/icon';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import CourierAccount from '../CourierAccount';
import DeliveryMethod from '../DeliveryMethod';
import PackingSlip from '../PackingSlip';
import styles from '../style.module.less';
import ParcelLocker from './ParcelLocker';
import PickPackProcessSettings from './PickPackProcessSettings';

const permissions = () => {
  const view_warehouse_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_warehouse_setting_page,
      }),
    ],
  });
  const view_courier_account_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_courier_account_setting_page,
      }),
    ],
  });
  const view_delivery_method_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_delivery_method_setting_page,
      }),
    ],
  });
  const view_parcel_lockers_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_parcel_lockers_setting_page,
      }),
    ],
  });
  const view_packing_slip_setting_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.view_packing_slip_setting_page,
      }),
    ],
  });
  const add_edit_warehouse_information = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.add_edit_warehouse_information,
      }),
    ],
  });

  return {
    view_warehouse_setting_page,
    view_courier_account_setting_page,
    view_delivery_method_setting_page,
    view_parcel_lockers_setting_page,
    view_packing_slip_setting_page,
    add_edit_warehouse_information,
  };
};
const WarehouseLocationSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_warehouse_information,
    view_warehouse_setting_page,
    view_courier_account_setting_page,
    view_delivery_method_setting_page,
    view_parcel_lockers_setting_page,
    view_packing_slip_setting_page,
  } = permissions();
  const history = useHistory();
  const { uuid }: any = useParams();
  const [urlQuery] = useUrlState();
  const [form] = Form.useForm();

  const [onSaveDisable, setOnSaveDisable] = useState<boolean>(true);
  const [onEditable, setOnEditable] = useState(uuid ? false : true);

  const [isDefault, setIsDefault] = useState<boolean>(false);

  const [title, setTitle] = useState<string>(
    getI18n('storeLogistics.warehouseLocations.addWarehouseLocation'),
  );
  const [defaultData, setDefaultData] = useState({});

  const breadcrumbData = useMemo(
    () =>
      defaultBreadcrumbData({ getI18n }).concat({
        url: '',
        name: title,
      }),
    [title],
  );

  const { loading: setWareHouseLocationLoading, run: _setWareHouseLocation } =
    useRequest((params) => setWareHouseLocation(params), {
      manual: true,
      onSuccess(result) {
        const { uuid = '' } = result;
        setOnSaveDisable(true);
        setOnEditable(false);
        setTitle((result || {}).locationName || '');
        history.replace(
          `/settings/logistics/warehouselocation/setting/${uuid}`,
        );
      },
    });

  const { loading: getWareHouseLocationLoading, run: _getWareHouseLocation } =
    useRequest((uuid) => getWareHouseLocation(uuid), {
      manual: true,
      onSuccess(result) {
        setTitle(result.locationName);
        setIsDefault(result.defaultLocation);
        setDefaultData(result);
        form.setFieldsValue({
          locationName: result.locationName,
          areaCode: result.areaCode,
          areaCodeInfo: result.areaCodeInfo,
          phone: result.phone,
          postcode: result.postcode || '',
          province: result.province,
          country: result.country,
          city: result.city,
          latitude: result.latitude || '',
          longitude: result.longitude || '',
          defaultLocation: result.defaultLocation,
          addressLine: result.addressLine,
          defaultWeightUnit: result.defaultWeightUnit,
        });
      },
    });

  useEffect(() => {
    if (uuid) {
      _getWareHouseLocation(uuid);
    }
    if (urlQuery.isdefault) {
      form.setFieldsValue({
        defaultLocation: true,
      });
    }
  }, []);

  const onValuesChange = () => {
    if (onSaveDisable) {
      setOnSaveDisable(!onSaveDisable);
    }
  };

  const onFormSubmit = () => {
    form.validateFields().then((res) => {
      const params = res;
      if (uuid) {
        params.uuid = uuid;
      }
      _setWareHouseLocation(params);
    });
  };

  const onGoBackClick = () => {
    history.push(`/settings/logistics`);
  };

  const onDiscard = () => {
    if (uuid) {
      setOnEditable(false);
      form.setFieldsValue(defaultData);
    } else {
      onGoBackClick();
    }
  };
  return (
    <div className={styles.warehouseLocationsSettingContainer}>
      {/* <RouteBlock
        onConfirm={(f) => f()}
        okText='Discard'
        active={uuid ? onEditable : !onSaveDisable}
        title={'Discard all unsaved changes'}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      /> */}

      <CommonHeader
        breadcrumbData={breadcrumbData}
        onSaveDisable={onSaveDisable}
        // onSubmit={onFormSubmit}
        // onDiscard={onGoBackClick}
        onGoBackClick={onGoBackClick}
      />
      <Spin
        spinning={getWareHouseLocationLoading || setWareHouseLocationLoading}>
        <div className={styles.commonContainer}>
          <Form
            form={form}
            colon={false}
            layout={'vertical'}
            className={styles.editForm}
            onValuesChange={onValuesChange}>
            <div className={styles.header}>
              <div className={styles.title}>{title}</div>
            </div>

            <div className={styles.content}>
              <CommonFormItem form={form} onEditable={onEditable} />
              <div className={styles.setDefault}>
                <Form.Item
                  name={'defaultLocation'}
                  extra={
                    <div className={styles.checkboxExtra}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.defaultLocationExtra',
                      )}
                    </div>
                  }
                  className={styles.checkbox}
                  labelAlign='left'
                  initialValue={true}
                  valuePropName='checked'>
                  <Checkbox disabled={isDefault || !onEditable}>
                    <span className={styles.checkboxText}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.defaultLocationLabel',
                      )}
                    </span>
                  </Checkbox>
                </Form.Item>
              </div>
            </div>
            <div className={styles.submitButton}>
              {uuid && !onEditable && (
                <Button
                  type='primary'
                  disabled={!add_edit_warehouse_information}
                  onClick={() => {
                    setOnEditable(true);
                  }}>
                  {getI18n('general.edit')}
                </Button>
              )}
              {(!uuid || onEditable) && (
                <Button
                  type='primary'
                  disabled={onSaveDisable || !add_edit_warehouse_information}
                  onClick={onFormSubmit}>
                  {getI18n('general.save')}
                </Button>
              )}
              {(!uuid || onEditable) && (
                <Button onClick={onDiscard}>
                  {getI18n('general.discard')}
                </Button>
              )}
            </div>
          </Form>

          {uuid && (
            <div className={styles.logisticsContainer}>
              {/*  Pick & Pack Process Settings*/}
              {view_warehouse_setting_page && (
                <div className={styles.container}>
                  <div className={styles.header}>
                    <div className={styles.title}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.pickPackProcessSettings',
                      )}
                    </div>
                    <div className={styles.description}></div>
                  </div>

                  <div className={styles.content}>
                    <PickPackProcessSettings warehouseUuid={uuid} />
                  </div>
                </div>
              )}
              {/* Courier Account */}
              {view_courier_account_setting_page && (
                <div className={styles.container}>
                  <div className={styles.header}>
                    <div className={styles.title}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.courierAccount',
                      )}
                    </div>
                    <div className={styles.description}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.courierAccountDescription',
                      )}
                    </div>
                  </div>
                  <div className={styles.content}>
                    <CourierAccount
                    //  warehouseList={warehouseList}
                    />
                  </div>
                </div>
              )}

              {/* Delivery Method */}
              {view_delivery_method_setting_page && (
                <div className={styles.container}>
                  <div className={styles.header}>
                    <div className={styles.title}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.deliveryMethod',
                      )}
                    </div>
                    <div className={styles.description}></div>
                  </div>

                  <div className={styles.content}>
                    <DeliveryMethod />
                  </div>
                </div>
              )}
              {/* Parcel Locker */}
              {view_parcel_lockers_setting_page && (
                <div className={styles.container}>
                  <div className={styles.header}>
                    <div className={styles.title}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.parcelLocker',
                      )}
                    </div>
                    <div className={styles.description}></div>
                  </div>

                  <div className={styles.content}>
                    <ParcelLocker warehouseUuid={uuid} />
                  </div>
                </div>
              )}

              {/* Packing Slip */}
              {view_packing_slip_setting_page && (
                <div className={styles.container}>
                  <div className={styles.header}>
                    <div className={styles.title}>
                      {getI18n('storeLogistics.warehouseLocations.packingSlip')}
                    </div>
                    <div className={styles.description}>
                      {getI18n(
                        'storeLogistics.warehouseLocations.packingSlipDescription',
                      )}
                    </div>
                  </div>

                  <div className={styles.content}>
                    <PackingSlip />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </Spin>
    </div>
  );
};

export default WarehouseLocationSetting;
